import React, { JSX, PropsWithChildren } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, useNavigate } from 'react-router'
import App from './components/App'
import '../app.css'
import { AppState, Auth0ContextInterface, Auth0Provider, Auth0ProviderOptions, User } from '@auth0/auth0-react'
const {
  VITE_AUTH0_CLIENT_ID: clientId,
  VITE_AUTH0_DOMAIN: domain,
  VITE_GQL_ENDPOINT: audience
} = import.meta.env

const Auth0ProviderWithRedirectCallback = ({
  children,
  context,
  ...props
}: PropsWithChildren<Omit<Auth0ProviderOptions, 'context'>> & {
  context?: React.Context<Auth0ContextInterface<User>>
}): JSX.Element => {
  const navigate = useNavigate()
  const onRedirectCallback = (appState?: AppState): void => {
    void navigate((appState?.returnTo) ?? window.location.pathname)
  }
  return (
    <Auth0Provider
      onRedirectCallback={onRedirectCallback}
      context={context}
      {...props}
    >
      {children}
    </Auth0Provider>
  )
}

const rootDOM = createRoot(document.getElementById('root') as Element)

rootDOM.render(
  <Router>
    <Auth0ProviderWithRedirectCallback
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience
      }}
    >
      <App />
    </Auth0ProviderWithRedirectCallback>
  </Router>
)
